module.exports = __webpack_public_path__ + "img/cancelWhite.bab082f6.svg";